module.exports = __webpack_public_path__ + "img/Alan Cheung.35c826c5.jpg";